import { AppPages } from 'src/pages/app'

const AppRoutes = [
  {
    path: '/administrator',
    component: <AppPages.Home />,
    exact: true,
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/administrator/privacy-policy',
    component: <AppPages.Policy />,
    exact: true,
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/administrator/settings',
    component: <AppPages.Settings />,
    exact: true,
    meta: {
      privateRoute: true,
      roles: ['admin', 'provider']
    }
  }
]

export default AppRoutes
